import { InitializableEntity } from '@core/entities/_extra/intializable.entity';
import { ChangeRequest } from '@core/entities/_extra';

export class MemberEntity extends InitializableEntity {
  lastName: string;
  firstName: string;
  birthDate: string;
  titleId: number;
  memberId: string;
  title: string;
  salutationId: string;
  salutation: string;
  letterSalutationId: any;
  letterSalutation: any;
  maritalStatusId: any;
  maritalStatus: any;
  emergencyContact: number;
  emergencyPhone: number;
  userRole: any;
  gender: string;
  pobox: any;
  poboxPostCode: any;
  street: string;
  street2: any;
  poboxCity: any;
  postCode: string;
  city: string;
  country: string;
  countryCode: number;
  membershipNumber: string;
  membershipStartDate: string;
  shareBirthday: boolean;
  bankData: BankEntity;
  email: string;
  phone: string;
  memberPhoto: boolean;
  changeRequest: ChangeRequests;

  constructor(init?: Partial<MemberEntity>) {
    super();
    this.initEntity(init);
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export class BankEntity {
  name: string;
  iban: string;
  bic: string;
  owner: string;
}

interface ChangeRequests {
  member: ChangeRequest<MemberEntity>;
  bank: ChangeRequest<BankEntity>;
}
